// Module
var code = `<div class="menu-container" style="position:absolute;cursor:default;{{#.width}}width:{{.width}}px;{{/}}
{{#.top}}top:{{.top}}px;{{/}}{{#.left}}left:{{.left}}px;{{/}}">
    {{#if .showContextMenu}}
    <div id="fromContextMenu" class="menu_style {{.isDarkStyle?'dark':'light'}}_style_menu" style="overflow: hidden;">
            {{#each itemsMenu: i}}
            <div class="menu_item" on-click="@this.private_onItemClick(event,this)">
                {{#if itemsMenu[i].imgStyle}}
                <div class="menu_item_img">
                    <div class="{{itemsMenu[i].imgStyle}}"></div>
                </div>
                {{elseif itemsMenu[i].canCheck}}
                <investingCheckBox styleClassed="menu_item_cheсkBox" checked="{{itemsMenu[i].checked}}"/>
                {{/if}}
                <div class="menu_item_text">{{itemsMenu[i].text}}</div>
            </div>
            {{/each}}
    </div>
    {{/if}}
</div>`;
// Exports
export default code;